import Phaser from "phaser";
export default class ObstacleSprite extends Phaser.GameObjects.Sprite {
  constructor(scene, x, y, texture, name, isWalkable) {
    super(scene, x, y, texture);
    this.name = name;
    this.isWalkable = isWalkable;
  }
}
